import React from "react";
import usePageTitle from "../../lib/usePageTitle";
import "../../styles/auth-web.css";

/**
 * Mockup viewAuth(): split art panel + centered card. Below 860px the art panel is hidden, so a
 * compact brand header (with the page's h1) sits above the card instead.
 */
export default function AuthShell({ children }) {
  usePageTitle();
  return (
    <div className="auth">
      <div className="auth-art">
        <div className="brand" style={{ padding: 0 }}>
          <div className="brand-mark" style={{ background: "var(--white)", color: "var(--deep)" }}>V</div>
          <b style={{ color: "var(--white)" }}>VibeLink</b>
        </div>
        <div>
          <h1>Find your people at the U.</h1>
          <p style={{ opacity: 0.85, marginTop: 14, maxWidth: 420, fontSize: 15 }}>
            Clubs, events and chats for University of Miami students, now in your browser too.
          </p>
        </div>
        <div className="row" style={{ gap: 18, opacity: 0.9, fontWeight: 700 }}>
          <span>Every UM club</span><span>·</span><span>Weekly events</span><span>·</span><span>@miami.edu only</span>
        </div>
      </div>
      <div className="auth-form">
        <div className="auth-card">
          <div className="auth-mbrand">
            <div className="brand-mark" aria-hidden="true">V</div>
            <h1>VibeLink</h1>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
